const logoData = [
    {
        image: 'https://res.cloudinary.com/huyphamcloud/image/upload/v1626348650/tuoitre/LogoTTTV_aidxnn.png',
        title: 'logo tuổi trẻ TV',
        path: '/',
        style: {width: '80px', height: '26px'}
    },
    {
        image: 'https://res.cloudinary.com/huyphamcloud/image/upload/v1626348678/tuoitre/tto_cuoituan_logo_iu0t8r.png',
        title: 'logo tuổi trẻ cuối tuần',
        path: '/',
        style: {width: '49px', height: '19px', marginRight: '10px', position: 'relative', top: '6px'}
    },
    {
        image: 'https://res.cloudinary.com/huyphamcloud/image/upload/v1626348705/tuoitre/LogoTTNews_bxm8dq.png',
        title: 'logo tuổi trẻ news',
        path: '/',
        style: {width: '80px', height: '26px'}
    },
    {
        image: 'https://res.cloudinary.com/huyphamcloud/image/upload/v1626348731/tuoitre/logo_tuoitrecuoi-01_ri7nr6.png',
        title: 'Tuổi Trẻ Cười',
        path: '/',
        style: {width: '75px'}
    },
];

export default logoData;